import { JSXElement, mergeProps } from 'solid-js';
import { getAppliedClasses } from '~/utils/commonUtils.ts';
import { twMerge } from 'tailwind-merge';

export enum BoxTypes {
  CENTRED = 'CENTRED',
  STRETCHED = 'STRETCHED',
  FULL = 'FULL'
}

type RightMainBoxProps = {
  boxType: BoxTypes;
  children: JSXElement;
  class?: string;
};

export function RightMainBox(props: RightMainBoxProps): JSXElement {
  const merged = mergeProps({}, props);
  return (
    <div
      class={twMerge(
        getAppliedClasses({
          'w-11/12 px-[5%]': merged.boxType === BoxTypes.CENTRED,
          'w-11/12': merged.boxType === BoxTypes.STRETCHED,
          'w-full': merged.boxType === BoxTypes.FULL
        }),
        merged.class
      )}
    >
      {merged.children}
    </div>
  );
}
